import { render, staticRenderFns } from "./IdentifyIsoelectronicPairs.vue?vue&type=template&id=9c958664&scoped=true&"
import script from "./IdentifyIsoelectronicPairs.vue?vue&type=script&lang=js&"
export * from "./IdentifyIsoelectronicPairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c958664",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer,VRow})
